<ng-container *ngIf="!isMaintenanceBreak; else maintenanceBreak">
  <div *ngIf="isLocalDeploy" class="local-login">
    <input type="number" placeholder="userId" (change)="localUserId = $event.target.value" *ngIf="!isUserLoggedIn">
    <button class="btn outline-primary small" (click)="loginOutLocal(!isUserLoggedIn)">
      <span *ngIf="!isUserLoggedIn">LOGIN</span>
      <span *ngIf="isUserLoggedIn">LOGOUT</span>
    </button>
    <span *ngIf="isUserLoggedIn"> Logged in as: {{loggedUserId}}</span>
  </div>
  <router-outlet></router-outlet>
  <app-svg-definitions></app-svg-definitions>

  <app-ticket-menu-bar [class.hide]='viewConfigurations.useMobileViewWithTopMenu || hideTitketMenuBar'></app-ticket-menu-bar>
</ng-container>

<ng-template #maintenanceBreak>
  <div class="maintenance-break">
    <h1 i18n="Maintenance title page@@maintenanceTitle">ODRŽAVANJE</h1>
    <img src="assets/img/animation.gif" alt="">
    <div class="text">
      <div i18n="Maintenance text page@@maintenanceText">U TOKU JE REDOVNO ODRŽAVANJE SISTEMA <br />SPORTSKE KLADIONICE
        ADMIRALBET</div>
      <!-- <div class="strip-line">
              <div i18n="Maintenance end text@@maintenanceEnd">očekivani završetak radova u</div>
              <span>10:00</span>
          </div> -->

      <div><span i18n="Maintenance thanks text@@maintenanceThanks">Hvala na strpljenju</span> <br /><span
          i18n="Maintenance thanks company@@maintenanceCompany">Vaš Admiral</span></div>
    </div>
  </div>
</ng-template>

<app-notification-dialog></app-notification-dialog>

<!-- Kept in the app shell so a single slip exists in the DOM, no matter which screen the cashier is on. -->
<app-ticket-print></app-ticket-print>
